import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import "./users.css";
import axios from "axios";

import { Box, Button, Container, Input, Table, Pagination, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

function Users() {
    function formatDate(m) {
        new Date(m);
        const dateString =
            m.getUTCFullYear() +
            "/" +
            ("0" + (m.getMonth() + 1)).slice(-2) +
            "/" +
            ("0" + m.getDate()).slice(-2) +
            "  " +
            ("0" + m.getHours()).slice(-2) +
            ":" +
            ("0" + m.getMinutes()).slice(-2);
        return dateString;
    }
    const [data, setData] = useState(null);
    const [users, setUser] = useState(null);
    const [load, setLoad] = useState(false);
    const [searched, setSearched] = useState("");
    const navigate = useNavigate();
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    //const [employee, setEmployee] = useState();
    useEffect(() => {
        if (load == false) {
            axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getall`, {})
                .then((res) => {
                    localStorage.setItem("data", JSON.stringify(res.data.data));
                    setData(res.data.data);
                    setUser(res.data.data);
                    setLoad(true);
                })
                .then((res) => setLoad(true));
            /*axios
                .get(`${process.env.REACT_APP_API_URL}/auth/getEmployee`, {})
                .then((res) => {
                    localStorage.setItem("data", JSON.stringify(res.data.data));
                    setEmployee(res.data.data);
                    setLoad(true);
                })
                .then((res) => setLoad(true));*/
        }
    }, [load]);
    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);

        if (searchedVal !== "") {
            const filteredRows = JSON.parse(localStorage.getItem("data")).filter((row) => {
                const a =
                    row?.user?.username?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase()) ||
                    row?.user?.name?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const b =
                    Number(row?.user?.iduser).toString().toLowerCase().includes(searchedVal.toString().toLowerCase()) ||
                    row?.stk?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const c =
                    row?.user?.ip?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase()) ||
                    row?.fullname?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase());
                const d =
                    row?.user?.sdt?.toString().toLowerCase().includes(searchedVal.toString().toLowerCase()) ||
                    searchedVal.toString().toLowerCase().includes(row?.user?.sdt?.toString().toLowerCase());
                return a || b || c || d;
            });
            setUser(filteredRows);
        } else {
            setUser(JSON.parse(localStorage.getItem("data")));
        }
    };
    const [pages, setPage] = useState(1);

    const handleChange = (e, page) => {
        setPage(page);
    };
    if (data) {
        return (
            <>
                <ThemeProvider theme={theme}>
                    <DashboardLayout>
                        {
                            <Box
                                component="main"
                                sx={{
                                    flexGrow: 1,
                                    py: 1
                                }}>
                                <Container maxWidth={false}>
                                    <div className="container_set">Danh sách user</div>
                                    <div className="form_set">
                                        <Box sx={{ minWidth: 600 }}>
                                            <TextField
                                                value={searched}
                                                onChange={(searchVal) => requestSearch(searchVal.target.value)}
                                                placeholder="Tìm kiếm"
                                                sx={{ marginBottom: "5px", paddingRight: "700px" }}
                                            />
                                            <Table className="table-admin">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ padding: "10px" }}>ID User</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Username</TableCell>
                                                        {/*<TableCell sx={{ padding: "10px" }}>Ng Giới Thiệu</TableCell>*/}
                                                        <TableCell sx={{ padding: "10px" }}>Số Dư</TableCell>
                                                        <TableCell sx={{ padding: "10px", minWidth: "200px" }}>Rút/ Nạp Tiền</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Thưởng</TableCell>
                                                        {/*<TableCell sx={{padding:"10px"}}>Ngày tạo</TableCell>
														<TableCell sx={{padding:"10px"}}>Admin Cộng</TableCell>
														<TableCell sx={{padding:"10px"}}>Admin Trừ</TableCell>
														<TableCell sx={{padding:"10px"}}>Admin Thưởng</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Tổng Cược</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Tổng Thắng</TableCell>*/}
                                                        <TableCell sx={{ padding: "10px" }}>Tên</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Ngân hàng</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>STK</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>SDT</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Tổng cược</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Cược chưa trả</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>IP cuối</TableCell>
                                                        <TableCell sx={{ padding: "10px" }}>Xem Thông Tin</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {users != null ? (
                                                    <TableBody>
                                                        {users?.slice((pages - 1) * 30, (pages - 1) * 30 + 30).map((item) => (
                                                            <>
                                                                <TableRow sx={{ verticalAlign: "top" }}>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.iduser}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.username}</TableCell>
                                                                    {/*<TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                        {employee && employee.find((x) => x.code === item?.user?.aff)?.username}
                                                                    </TableCell>*/}
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.money?.toLocaleString()}</TableCell>
                                                                    {/*<TableCell sx={{ fontWeight: "600", padding: "10px" }}>
																	        {formatDate(new Date(item?.user?.createdAt))}
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                            {item?.user?.adminadd.toLocaleString()}
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                            {item?.user?.admintru.toLocaleString()}
                                                                        </TableCell>
                                                                        <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                            {item?.user?.adminthuong.toLocaleString()}
                                                                        </TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.totalbet.toLocaleString()}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.totalwin.toLocaleString()}</TableCell>*/}
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px", fontSize: "12px" }}>
                                                                        <form
                                                                            onSubmit={(e) => {
                                                                                e.preventDefault();
                                                                                const dataForm = {
                                                                                    id: item?.user?._id,
                                                                                    money: e.target.money.value,
                                                                                    type: e.target.type.value
                                                                                };
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/update`, dataForm).then((res) => {
                                                                                    setData(res.data.data);
                                                                                    setLoad(false);
                                                                                    swal("Cộng/Trừ tiền thành công!");
                                                                                });
                                                                            }}>
                                                                            <input style={{ width: "100px" }} id={item?.user?._id} name="money" type="number" />
                                                                            <Button type="submit" sx={{ padding: "3px", color: "#c9573b" }}>
                                                                                Xác nhận
                                                                            </Button>
                                                                            <br />
                                                                            <input name="type" type="radio" checked value="0" />
                                                                            Lưu lịch sử
                                                                            <input name="type" type="radio" value="1" />
                                                                            Không lưu
                                                                        </form>
                                                                    </TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                        <form
                                                                            onSubmit={(e) => {
                                                                                e.preventDefault();
                                                                                const dataForm = {
                                                                                    id: item?.user?._id,
                                                                                    money: e.target.money.value
                                                                                };
                                                                                axios.post(`${process.env.REACT_APP_API_URL}/auth/adminthuong`, dataForm).then((res) => {
                                                                                    setLoad(false);
                                                                                    swal("Thưởng thành công!");
                                                                                });
                                                                            }}>
                                                                            <input style={{ width: "100px" }} id={item?.user?._id} name="money" type="number" />
                                                                            <br />
                                                                            <Button type="submit" sx={{ padding: "3px", color: "#c9573b" }}>
                                                                                Xác nhận
                                                                            </Button>
                                                                        </form>
                                                                    </TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.fullname}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.name_bank}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.stk}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>
                                                                        {item?.user?.sdt ? "0" + item?.user?.sdt : ""}
                                                                    </TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.totalbet?.toLocaleString()}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.processing?.toLocaleString()}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", padding: "10px" }}>{item?.user?.ip}</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", display: "flex" }}>
                                                                        {item?.user?.isLock == false ? (
                                                                            <Button
                                                                                onClick={() => {
                                                                                    axios
                                                                                        .post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, {
                                                                                            id: item?.user?._id,

                                                                                            isLock: true
                                                                                        })
                                                                                        .then((res) => {
                                                                                            setLoad(false);
                                                                                        });
                                                                                }}>
                                                                                Khóa
                                                                            </Button>
                                                                        ) : (
                                                                            <Button
                                                                                onClick={() => {
                                                                                    axios
                                                                                        .post(`${process.env.REACT_APP_API_URL}/auth/lockkey`, {
                                                                                            id: item?.user?._id,

                                                                                            isLock: false
                                                                                        })
                                                                                        .then((res) => {
                                                                                            setLoad(false);
                                                                                        });
                                                                                }}>
                                                                                Mở
                                                                            </Button>
                                                                        )}
                                                                        <Button onClick={() => navigate(`/admin/user/${item?.user?._id}`)}>Xem</Button>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </>
                                                        ))}
                                                    </TableBody>
                                                ) : (
                                                    <div>Đang cập nhật</div>
                                                )}
                                            </Table>
                                        </Box>
                                    </div>
                                    {searched.length < 1 && (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "center",
                                                pt: 3
                                            }}>
                                            {data != null ? <Pagination color="primary" count={Math.floor(data.length / 30) + 1} size="small" onChange={handleChange} /> : null}
                                        </Box>
                                    )}
                                </Container>
                            </Box>
                        }
                    </DashboardLayout>
                </ThemeProvider>
            </>
        );
    } else {
        return <></>;
    }
}
export default Users;
